enum constants {
	parentContainerId = '_idContainer',
	textFieldWrapperClassName = '_idGenObjectAttribute',
	textFieldCharacterClassName = 'CharOverride',
	textFieldClassName = 'editable-text',
	imageClassName = 'editable-image',
	videoClassName = 'editable-video',
	videoWrapperId = '_idHTMLPageItem',
	buttonClassName = '_idGenButton',
	animationEndStateDataAttribute = 'idgenanimationendstate',
	editableButtonClassName = 'editable-button',
	editableButtonGraphicsClassName = '_idGenObjectStyle',
	lockedClassName = 'locked',
}

export default constants;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/constants.ts